module.exports = __webpack_public_path__ + "static/media/logo-black-2.dc467834.svg";